module.exports = __webpack_public_path__ + "img/ProspectCRM-initial-splash.6d9f84ac.png";